import ActionList, { Props } from './ActionList';
import { ActionListContextProvider, useActionListContext } from '../context';

type ContainerProps = Omit<
  Props,
  'currentError' | 'currentStatus' | 'currentIndex' | 'retry'
>;

const ActionListContainer = (props: ContainerProps) => {
  const { currentError, currentStatus, retry, currentIndex } =
    useActionListContext();

  return (
    <ActionList
      {...props}
      currentError={currentError}
      currentStatus={currentStatus}
      retry={retry}
      currentIndex={currentIndex}
    />
  );
};

const ActionListContextContainer = (props: ContainerProps) => {
  return (
    <ActionListContextProvider>
      <ActionListContainer {...props} />
    </ActionListContextProvider>
  );
};

export default ActionListContextContainer;
